import { getOpeningHours } from './get-opening-hours.js';
import { getSpecialOpeningHours } from './get-special-opening-hours.js';

const getOpeningHoursSpecification = (store)=>{
    var _specialOpeningHours;
    return [
        ...getOpeningHours(store),
        ...getSpecialOpeningHours((_specialOpeningHours = store.specialOpeningHours) !== null && _specialOpeningHours !== void 0 ? _specialOpeningHours : [])
    ];
};

export { getOpeningHoursSpecification };
//# sourceMappingURL=get-opening-hours-specification.js.map
